import type {Schemas} from 'api/dto.generated';
import type {AvailableFilter} from '../types';

export const mapAvailableFilters = (
  dto: Schemas.AvailableFilter[],
): AvailableFilter[] => {
  return dto.map(mapAvailableFilter);
};

export const mapAvailableFilter = (
  dto: Schemas.AvailableFilter,
): AvailableFilter => {
  return {
    ...dto,
    codelistId: dto.codelistId as Schemas.CodelistDto['id'],
  };
};
